export default {"src":"/_next/static/media/icGiftActive.33248b90.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};